export default __webpack_public_path__ + "static/media/element_34.4c898d63.webp";